export const TOWNS = [
  {
    slug: "hanover-pa",
    name: "Hanover, PA",
    tag: "Home base",
    blurb:
      "Our home base — which means the fastest response times in the area. Same-day pickups across town, from the row homes near the square to the farms and new builds on the edge of town. Call in the morning and your junk can be gone by dinner.",
    towns: "Hanover · McSherrystown · Penn Township · Conewago Township · Parkville",
    jobs: ["Garage cleanouts", "Furniture removal", "Appliance haul-away", "Estate cleanouts", "Yard debris", "Light demolition"],
  },
  {
    slug: "york-pa",
    name: "York, PA",
    tag: "Same-day available",
    blurb:
      "Full-service junk removal across the White Rose City and greater York County. Row home cleanouts downtown, suburban garage and basement jobs, office and retail cleanouts for local businesses — one upfront price, and we do all the lifting.",
    towns: "York · Spring Grove · Red Lion · Dallastown · Shrewsbury · Dover",
    jobs: ["Basement cleanouts", "Furniture removal", "Office cleanouts", "Moving prep hauls", "Yard debris", "Renovation debris"],
  },
  {
    slug: "lancaster-pa",
    name: "Lancaster, PA",
    tag: "By appointment",
    blurb:
      "Serving Lancaster County by appointment — from city row homes to country barns and everything in between. Moving prep, renovation debris, furniture and appliance removal. You approve the price before we lift a thing.",
    towns: "Lancaster · Lititz · Manheim · Ephrata · Columbia · Mount Joy",
    jobs: ["Whole-home cleanouts", "Furniture removal", "Barn & shed cleanouts", "Yard debris", "Rental turnovers", "Appliance haul-away"],
  },
  {
    slug: "gettysburg-pa",
    name: "Gettysburg, PA",
    tag: "Same-day available",
    blurb:
      "Serving Gettysburg and all of Adams County — rental turnovers near town, estate cleanouts handled with care, and rural properties with years of accumulated stuff. We sweep up before we leave and donate or recycle everything we can.",
    towns: "Gettysburg · Littlestown · New Oxford · Abbottstown · Biglerville",
    jobs: ["Estate cleanouts", "Rental turnovers", "Furniture removal", "Yard debris", "Light demolition", "Garage cleanouts"],
  },
  {
    slug: "westminster-md",
    name: "Westminster, MD",
    tag: "By appointment",
    blurb:
      "Covering Westminster and all of Carroll County — from downtown homes to the farms and horse properties out of town. Home cleanouts, yard debris, shed tear-downs, and estate work. We run down from Hanover, so booking a day or two ahead locks in your spot.",
    towns: "Westminster · Taneytown · Manchester · Hampstead · Sykesville · Eldersburg",
    jobs: ["Home cleanouts", "Furniture removal", "Yard debris", "Shed & deck demolition", "Estate cleanouts", "Barn cleanouts"],
  },
];

export const getTown = (slug) => TOWNS.find((t) => t.slug === slug);
